export default {
    no_data: 'Er zijn geen gegevens om te laten zien',
    loading: 'Records laden',
    search: 'Zoeken',
}